import React from 'react';
import PropTypes from 'prop-types';
import { useRef, useEffect } from 'react';
import { formatPrice, getFinanceWeekly, getLeaseBiWeeklyFromMsrp, getLeaseBiWeeklyFromOptions } from '../../../utils';
import ReactHtmlParser from 'react-html-parser';
import { SummaryConstants as Constants } from '../../../Helpers/summaryconstants';
import { useTranslation } from "react-i18next";

export const PackageCard = ({ Package, PopContent, ButStyle, ButContent, Selected, ButSelectedContent, SelectedIndex, HandleSelectedPackage, HandleRemovePackage, HasCollapse=true, Index, showFinancePrice, isUniversal, displayPriceCalculation = true, displayConnectedServicePriceCalculation = false, ...props }) => {
    const summaryCalculator = window.summaryCalculator;
    const [packageData, setPackageData] = React.useState(Package);
	const [financial, setFinancial] = React.useState(summaryCalculator.FinancialInfo);
    const packageCost = packageData.financial.msrp;
    const { t, i18n } = useTranslation(['packages', 'general']);
	const [expandedIndex, setExpandedIndex] = React.useState(null);
	const collapseRef = useRef(null);
	const [toggle, setToggle] = React.useState(false);
	const isExpanded = false;
	    
	function getConnectivityPackageDesc(){
		let packageDesc;

		/*if(packageArr && packageArr.length === 0){
			packageDesc=packageData.description;
		}else{
			packageDesc= packageData.features.map((feature, index) => {return `<li class="package-card__list-item" key=${index}>${feature.content}</li>`});
			packageDesc = `<ul class="package-card__list">${packageDesc.join('')}</ul>`;
		}*/
		//

		packageDesc= `<li class="package-card__list-item" >${packageData.title}</li>`;
		packageDesc = `<ul class="package-card__list">${packageData.subtitle}</ul>`;		
		return packageDesc;
	}

	function getPackageDesc(){
		let packageArr=packageData.features;
		let packageDesc;

		if(packageArr && packageArr.length === 0){
			packageDesc=packageData.description;
		}else{
			packageDesc= packageData.features.map((feature, index) => {return `<li class="package-card__list-item" key=${index}>${feature.content}</li>`});
			packageDesc = `<ul class="package-card__list">${packageDesc.join('')}</ul>`;
		}

		return packageDesc;
	}

	// DO NOT REMOVE THIS IS USED TO REFRESH WHEN AN ENGINE AND DRIVETRAIN GET SELECTED
	useEffect(() =>{
		setPackageData(Package);

		const collapse = collapseRef.current; 
        if(typeof window.mzAnimator === 'object' ){
            window.mzAnimator.animateHeight(collapse, 'PackageList' + Index, 'init', toggle)
        }
	}, [Package]);
    
    useEffect(() =>{
        const collapse = collapseRef.current;
        window.mzAnimator.animateHeight(collapse, 'PackageList' + Index, toggle)
   },[toggle]);

    async function setSelectedPackage(index) {
        await HandleSelectedPackage(index);
    }

    async function removeSelectedPackage(index) {
        await HandleRemovePackage(index);
    }

	function handleCollapse(e){
			const $el = e.target;

			if (isExpanded !== null && expandedIndex !== null && Index !== null) {
				if (isExpanded === true) {
					setExpandedIndex(null);
				} else {
					setExpandedIndex(Index);
					setTimeout(()=>{
						const collapseTarget = e.target.closest('.mz-collapse');
						if(collapseTarget){
							const scrollWindow = document.querySelector('.mz-package-page__package-card-list');
							const topScroll = collapseTarget.offsetTop;
							scrollWindow.scroll({
							  top:topScroll,
							  behavior: 'smooth'
							});
						}
					},100);
				}
			} else {
				setToggle(!toggle);
			}
	}
	const showPrice = ()=>{
		let spanCont;
		if(isUniversal){
			return (<p className="package-card__price noUpper">{t('warrantyDisclaimer')}</p>);
		}else{
			if(packageCost!==null && displayPriceCalculation){
				spanCont = showFinancePrice?
						`(${getFinanceWeekly(packageCost, financial.calculatedFinance.financeValues[summaryCalculator.FinanceTermIndex].aprRate, financial.calculatedFinance.financeValues[summaryCalculator.FinanceTermIndex].term)}${t("general:week")})`:
						!window.hideLeaseInCard ? `(${getLeaseBiWeeklyFromMsrp(packageCost, financial.calculatedLease.leaseValues[summaryCalculator.LeaseTermIndex].leaseRate, financial.calculatedLease.leaseValues[summaryCalculator.LeaseTermIndex].term)}${t("general:bi_week")})` : ''
			}
			if(packageCost!==null && displayConnectedServicePriceCalculation) {
				spanCont = showFinancePrice?
						`(${getFinanceWeekly(packageCost, financial.calculatedFinance.financeValues[summaryCalculator.FinanceTermIndex].aprRate, financial.calculatedFinance.financeValues[summaryCalculator.FinanceTermIndex].term)}${t("general:week")})`:
						`(${getLeaseBiWeeklyFromOptions(packageCost, financial.calculatedLease.leaseValues[summaryCalculator.LeaseTermIndex].leaseRate, financial.calculatedLease.leaseValues[summaryCalculator.LeaseTermIndex].term)}${t("general:bi_week")})`

			}
			return(<p className="package-card__price">+&nbsp;{formatPrice(packageCost)} <span>{spanCont}</span></p>);
		}
	}

    return (
		<div className={`mz-collapse package-card ${Selected ? 'mz-collapse-selected selected' : ''}`}>
            <div
                onClick={handleCollapse}
                className="mz-collapse__button"
            >	
				{Selected && !ButSelectedContent &&
					<div className="mz-check-indicator"><i className="mz-svg mz-svg--white mz-svg-checkmark"></i></div>
				}
				{Package.popular===1 && <div className="package-card__popular label">{PopContent}</div>}
				<h3 className="package-card__title">{packageData.name}</h3>
				{!HasCollapse && <div>{ReactHtmlParser(displayConnectedServicePriceCalculation ? getConnectivityPackageDesc() : getPackageDesc())}</div>}
				{showPrice()}
				{HasCollapse && <><i className={`mz-svg mz-svg-chevron ${toggle ? 'mz-svg--rotate270':''}`}></i>
				<hr /></>}
			</div>
			{HasCollapse && <div className="mz-collapse__box" ref={collapseRef}>{ReactHtmlParser(getPackageDesc())}</div>}
			<div>
				{Selected ? 
					ButSelectedContent ? 
						<button className="mz-btn mz-btn--primary package-card__button" onClick={()=>removeSelectedPackage(Index)}><span>{ButSelectedContent}</span></button>  
					: 
						<button className="mz-btn mz-btn--primary package-card__button" onClick={()=>removeSelectedPackage(Index)}><span>{t("button_remove_package")}</span></button> 
				: 
					ButContent ?
						<button className="mz-btn mz-btn--primary mz-btn--red package-card__button" onClick={()=>{setSelectedPackage(Index);}}><span>{ButContent}</span></button>
					:
					<button  className="mz-btn mz-btn--primary mz-btn--red package-card__button"  onClick={()=>{setSelectedPackage(Index);}}>
						<span>{t("button_select_package")}</span>
					</button>
				}
			</div>
		</div>
    )
}


export default PackageCard;

PackageCard.propTypes = {
    HandleSelectedPackage: PropTypes.func,
    HandleRemovePackage:  PropTypes.func,
}

PackageCard.defaultProps = {
    HandleSelectedPackage: () => {},
    HandleRemovePackage: () => {},
};